// Injects the season background image style into the document head. All you need to keep the season modal
// bg image updated is to put the images in the public/img/ folder with the naming convention seasonBg{seasonId}.png
export const injectSeasonBgStyle = async (seasonId: number) => {
  const className = `season-bg-${seasonId}`;
  const styleId = `style-${className}`;
  const availableBgImage = await getHighestAvailableSeasonId();
  if (document.getElementById(styleId)) return; // Avoid duplicate styles
  const style = document.createElement('style');
  style.id = styleId;
  style.innerHTML = `
      .${className} {
        background-image: url('/img/seasonBg${availableBgImage}.jpg');
      }
    `;
  document.head.appendChild(style);
};

// const checkImageExists = (src: string) => {
//   return new Promise((resolve) => {
//     const img = new Image();
//     img.onload = () => resolve(true);
//     img.onerror = () => resolve(false);
//     img.src = src;
//   });
// };

const getHighestAvailableSeasonId = async () => {
  // let highestValidId = null;
  return 7;

  // for (let i = 1; i <= maxCheck; i++) {
  //   const exists = await checkImageExists(`/img/seasonBg${i}.jpg`);
  //   if (exists) highestValidId = i;
  // }

  // return highestValidId;
};
